/* Waterfall chart module */
import cloneDeep from 'lodash/cloneDeep';
import waterfallChartConfigBuilder from './waterfall-chart-config-builder';
import { columnTooltip } from '../../widget-utilities/widget-tooltip';
import d3Utils from '../../../../utils/d3Utils';
import chartUtils from '../../../../utils/chart-utils';

var waterfallChart = function waterfallChart() {
  var renderWidget = function renderWidget(widgetConfig) {
    var ContainerId = widgetConfig.ContainerId,
        Model = widgetConfig.Model,
        Width = widgetConfig.Width,
        Height = widgetConfig.Height,
        FontWidth = widgetConfig.FontWidth,
        FontHeight = widgetConfig.FontHeight,
        Cloud = widgetConfig.Cloud,
        ColorScheme = widgetConfig.ColorScheme,
        Data = widgetConfig.Data,
        ChartConfig = widgetConfig.ChartConfig;


    var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;

    var el = window.document.querySelector('#' + ContainerId);
    d3.select(el).select("svg").remove();

    var modelName = Model;
    var margin = { top: 0.02, right: 0.02, bottom: 0.01, left: 0.03 },
        width = Number(chartUtils.replaceAll(Width, '\x01', "")),
        height = Number(chartUtils.replaceAll(Height, '\x01', "")),
        fontWidth = Number(FontWidth),
        fontHeight = Number(FontHeight);

    var hPadding = 0.02;
    var vPadding = 0.1;

    var xFieldName = ChartConfig.XAxisField,
        yFieldName = ChartConfig.YAxisFields[0],
        CrumbFieldConfig = ChartConfig.CrumbFieldConfig,
        crumbFieldName = CrumbFieldConfig[Object.keys(CrumbFieldConfig)[0]],
        crumbDisplayFieldName = ChartConfig.CrumbDisplayFieldName,
        crumbFormat = {
      CloudName: Cloud,
      ModelName: modelName,
      Type: "Node",
      Name: Object.keys(CrumbFieldConfig)[0],
      FieldName: crumbFieldName,
      Value: "",
      DisplayFieldName: crumbDisplayFieldName,
      DisplayValue: null
    },
        xAxisText = ChartConfig.XAxisName,
        yAxisText = ChartConfig.YAxisNames[0],
        displayFormat = ChartConfig.ValueFormat,
        currencyPrefix = ChartConfig.CurrencySymbol,
        rotationAngle = Number(ChartConfig.RotationAngle),
        baseFormat = ChartConfig.BaseFormat;

    var tickCount = Number(ChartConfig.TickCount);
    var tipField = ChartConfig.TipField;
    var showLegend = ChartConfig.ShowLegend;
    var showTotal = ChartConfig.ShowTotal;
    var sortByDate = ChartConfig.SortByDate;
    var hideXAxis = ChartConfig.HideXAxis;
    var hideYAxis = ChartConfig.HideYAxis;
    var isDecimalPercentNumber = false;
    var seriesConfig = ChartConfig.Series;
    var seriesData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.seriesData), '\x001', ""));
    var seriesAccumulators = {};
    var maxValue = 0;
    var minValue = 0;
    var accumulator = [];
    var baseXValues = [];
    var base = "base";
    var totalLabel = ChartConfig.TotalLabel;
    var barSeriesNames = [];
    var defaultAxis = "seriesAxis";
    var accumulationType = ChartConfig.AggregationType;
    var colorScheme = JSON.parse(chartUtils.replaceAll(JSON.stringify(ColorScheme), '\x01', ""));
    var legendLineCount = Number(ChartConfig.LegendLineCount);
    var legendLocation = ChartConfig.LegendLocation;
    var defaultPerspective = ChartConfig.DefaultPerspective;

    var legendRectSize = 0.04;
    var legendVerticalPad = 0.08;
    var legendSpacing = 0.004;
    var legendWidth = 0.1;
    var offset = 0.005;

    var yAxisTickSpacing = Number("0.05");
    var xAxisTickSpacing = Number("0");

    var yAxisLabelSize = 0.05;
    var xAxisLabelSize = 0.05;
    var textOffset = "0";
    var transitionEase = "linear";

    if (tickCount == 0) tickCount = 10;

    if (isNaN(xAxisTickSpacing)) xAxisTickSpacing = 0;

    if (Number(xAxisTickSpacing) >= 1) xAxisTickSpacing = Number(xAxisTickSpacing) / 100;

    if (isNaN(yAxisTickSpacing)) yAxisTickSpacing = 0;

    if (Number(yAxisTickSpacing) >= 1) yAxisTickSpacing = Number(yAxisTickSpacing) / 100;

    if (xFieldName == "") xFieldName = defaultAxis;

    if (yAxisText == "") yAxisLabelSize = 0;

    if (xAxisText == "") xAxisLabelSize = 0;

    if (totalLabel == "") totalLabel = "Total";

    var x = d3.scale.ordinal();

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear();

    var seriesColor = d3.scale.category20();
    var totalAccumulator = [];

    if (colorScheme != null && colorScheme.length > 0) seriesColor = d3.scale.ordinal().range(colorScheme);

    var totalConfig = {
      SeriesType: chartUtils.chartSeriesType.bar,
      FieldName: totalLabel,
      SeriesName: totalLabel,
      ValueFormat: displayFormat,
      CurrencySymbol: currencyPrefix,
      CrumbMetaName: crumbFormat.name,
      CrumbFieldName: crumbFieldName
    };

    // Accumulate data and compute the base for each series
    if (seriesConfig != null) {
      for (var index = 0; index < seriesConfig.length; index++) {
        var series = seriesConfig[index];

        if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

        if (seriesData[series.SeriesName] == null) continue;

        var seriesItemData = JSON.parse(seriesData[series.SeriesName]);

        var tempAccumulator = [];

        var seriesName = chartUtils.replaceAll(series.SeriesName, " ", "");

        var value = null,
            baseValue = null,
            totalValue = null;

        var processed = {};
        if (seriesConfig.length == 1) {
          for (var i = 0; i < seriesItemData.length; i++) {
            var item = seriesItemData[i];

            var xFieldValue = item[xFieldName];
            if (xFieldValue == null) continue;

            var aggregationType = series.AggregationType == chartUtils.aggregationTypes.unknown ? accumulationType : series.AggregationType;

            var itemValue = item[series.FieldName];

            baseValue = chartUtils.findValue(baseXValues, xFieldName, xFieldValue);
            value = chartUtils.findValue(tempAccumulator, xFieldName, xFieldValue);

            //The current xFieldName is found the first time
            if (baseValue == null) {
              baseValue = {};
              baseValue[xFieldName] = xFieldValue;
              baseValue[base] = 0;
              baseValue[series.FieldName] = 0;

              if (series.CrumbDisplayFieldName != null && series.CrumbDisplayFieldName.trim().length > 0) baseValue[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

              baseXValues.push(baseValue);
            }

            if (value == null) {
              value = {};
              value[xFieldName] = xFieldValue;
              value[series.CrumbFieldName] = item[series.CrumbFieldName];
              value[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

              if (series.TipField != null && series.TipField.trim().length > 0) baseValue[series.TipField] = item[series.TipField];

              if (series.OrderField != null && series.OrderField.trim().length > 0) {
                baseValue[series.OrderField] = item[series.OrderField];
                value[series.OrderField] = item[series.OrderField];
              }

              if (series.ClassifierField != null && series.ClassifierField.trim().length > 0) value.Classifier = item[series.ClassifierField] != null ? chartUtils.makeStyleName(item[series.ClassifierField]) : item[series.ClassifierField];

              if (aggregationType == chartUtils.aggregationTypes.sum) value[series.FieldName] = Math.round(Number(itemValue) * 100) / 100;

              if (aggregationType == chartUtils.aggregationTypes.count) {
                value[series.FieldName] = 1;
              }

              if (aggregationType == chartUtils.aggregationTypes.uniqueCount) {
                value[series.FieldName] = 1;

                processed[item[xFieldName]] = [];
                processed[item[xFieldName]].push(item[series.FieldName]);
              }

              if (aggregationType == chartUtils.aggregationTypes.average) {
                value["total"] = itemValue == null ? 0 : Number(itemValue);

                if (item[xFieldName] == value[xFieldName] && item[series.FieldName] != null) value["counter"] = 1;else value["counter"] = 0;

                value[series.FieldName] = value["total"];
              }

              value[base] = baseValue[base];
              value["series"] = series.SeriesName;

              if (series.ClassifierField != null) value.Classifier = item[series.ClassifierField];

              if (series.SeriesType == chartUtils.chartSeriesType.bar) {
                if (!chartUtils.inArray(barSeriesNames, series.SeriesName)) barSeriesNames.push(series.SeriesName);
              }

              if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
                var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

                var tipValue = chartUtils.getTooltipValue(tipItem, item);

                if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

                if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

                if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

                if (tipItem.TipField == yFieldName && tipItem.AggregationType == "") tipValue = item[yFieldName];

                value[tipItem.Id] = tipValue;
              }
              tempAccumulator.push(value);
            } else {
              if (aggregationType == chartUtils.aggregationTypes.sum) {
                value[series.FieldName] += Math.round(Number(itemValue) * 100) / 100;
              }

              if (aggregationType == chartUtils.aggregationTypes.count) {
                value[series.FieldName]++;
              }

              if (aggregationType == chartUtils.aggregationTypes.uniqueCount) {
                // Avoid double counting
                if (processed[item[xFieldName]].indexOf(item[series.FieldName]) > -1) continue;
                value[series.FieldName]++;

                processed[item[xFieldName]].push(item[series.FieldName]);
              }

              if (aggregationType == chartUtils.aggregationTypes.average) {
                value["total"] += itemValue == null ? 0 : Number(itemValue);

                if (item[xFieldName] == value[xFieldName] && item[series.FieldName] != null) value["counter"]++;

                if (value["counter"] > 0) value[series.FieldName] = Number(value["total"] / value["counter"]);else value[series.FieldName] = 0;
              }
            }

            baseValue[series.FieldName] = value[series.FieldName];
          }

          var total = 0;

          var sortFieldName = series.OrderField == null ? series.FieldName : series.OrderField;
          var inverseSort = sortFieldName == series.FieldName ? true : false;
          if (baseXValues.length > 0) inverseSort = isNaN(baseXValues[0][sortFieldName]) ? false : true;

          chartUtils.sort(baseXValues, sortFieldName, null, inverseSort);
          chartUtils.sortByBaseSeries(baseXValues, tempAccumulator, xFieldName);

          if (tempAccumulator.length > 0) total = tempAccumulator[0][series.FieldName];

          if (tempAccumulator.length > 1) for (var i = 1; i < tempAccumulator.length; i++) {
            var item = tempAccumulator[i];
            var prevItem = tempAccumulator[i - 1];
            item.base = prevItem.base + prevItem[series.FieldName];
            total += item[series.FieldName];
          }

          var totalValue = {};
          totalValue[xFieldName] = totalLabel;
          totalValue[series.FieldName] = total;
          totalValue[base] = 0;
          totalValue.series = series.SeriesName;
          totalValue.Classifier = "total";

          if (showTotal) {
            tempAccumulator.push(totalValue);
            baseXValues.push(totalValue);
          }

          var tempMaxValue = d3.max(tempAccumulator, function (d) {
            return Math.round((Number(d[series.FieldName]) + Number(d[base])) * 100) / 100;
          });

          maxValue = Math.max(maxValue, tempMaxValue);

          var tempMinValue = d3.min(tempAccumulator, function (d) {
            return Math.round((Number(d[base]) + Number(d[series.FieldName])) * 100) / 100;
          });

          minValue = Math.min(minValue, tempMinValue);

          seriesAccumulators[seriesName] = tempAccumulator;
          continue;
        }

        for (var i = 0; i < seriesItemData.length; i++) {
          var item = seriesItemData[i];
          var aggregationType = series.AggregationType == chartUtils.aggregationTypes.unknown ? accumulationType : series.AggregationType;

          var itemValue = item[series.FieldName];
          if (series.IsDebit) {
            itemValue *= -1;
          }

          var xFieldValue = null;

          if (xFieldName != defaultAxis) {
            xFieldValue = item[xFieldName];
            if (xFieldValue == null) continue;
          } else xFieldValue = "default";

          baseValue = chartUtils.findValue(baseXValues, xFieldName, xFieldValue);
          totalValue = chartUtils.findValue(totalAccumulator, xFieldName, xFieldValue);
          value = chartUtils.findValue(tempAccumulator, xFieldName, xFieldValue);

          //The current xFieldName is found the first time
          if (baseValue == null) {
            baseValue = {};
            baseValue[xFieldName] = xFieldValue;
            baseValue[base] = 0;
            baseValue[series.FieldName] = 0;
            baseXValues.push(baseValue);
          }
          if (totalValue == null) {
            totalValue = {};
            totalValue[xFieldName] = xFieldValue;
            totalValue["Total"] = 0;
            totalValue[base] = 0;
            totalValue[totalConfig] = totalConfig.SeriesName;
            totalAccumulator.push(totalValue);
          }

          if (value == null) {
            value = {};
            value[xFieldName] = xFieldValue;
            value[series.CrumbFieldName] = item[series.CrumbFieldName];
            value[series.CrumbDisplayFieldName] = item[series.CrumbDisplayFieldName];

            if (series.TipField != null && series.TipField.trim().length > 0) baseValue[series.TipField] = item[series.TipField];

            if (aggregationType == chartUtils.aggregationTypes.sum) value[series.FieldName] = Math.round(Number(itemValue) * 100) / 100;

            if (aggregationType == chartUtils.aggregationTypes.count) {
              value[series.FieldName] = 1;
            }

            if (aggregationType == chartUtils.aggregationTypes.uniqueCount) {
              value[series.FieldName] = 1;

              processed[item[xFieldName]] = [];
              processed[item[xFieldName]].push(item[series.FieldName]);
            }

            if (aggregationType == chartUtils.aggregationTypes.average) {
              value["total"] = itemValue == null ? 0 : Number(itemValue);

              if (item[xFieldName] == value[xFieldName] && item[series.FieldName] != null) value["counter"] = 1;else value["counter"] = 0;

              value[series.FieldName] = value["total"];
            }

            value[base] = baseValue[base];
            value[series] = series.SeriesName;
            value["IsDebit"] = series.IsDebit;

            if (series.SeriesType == chartUtils.chartSeriesType.bar) {
              if (!chartUtils.inArray(barSeriesNames, series.SeriesName)) barSeriesNames.push(series.SeriesName);
            }

            if (series.Tooltip != null && series.Tooltip.TooltipConfigs != null && series.Tooltip.TooltipConfigs.length > 0) for (var tipIndex = 0; tipIndex < series.Tooltip.TooltipConfigs.length; tipIndex++) {
              var tipItem = series.Tooltip.TooltipConfigs[tipIndex];

              var tipValue = chartUtils.getTooltipValue(tipItem, item);

              if (tipItem.TipField == series.FieldName && tipItem.AggregationType == "") tipValue = item[series.FieldName];

              if (tipItem.TipField == series.crumbFieldName && tipItem.AggregationType == "") tipValue = item[series.crumbFieldName];

              if (tipItem.TipField == series.CrumbDisplayFieldName && tipItem.AggregationType == "") tipValue = item[series.CrumbDisplayFieldName];

              if (tipItem.TipField == yFieldName && tipItem.AggregationType == "") tipValue = item[yFieldName];

              value[tipItem.Id] = tipValue;
            }

            tempAccumulator.push(value);
          } else {
            if (aggregationType == chartUtils.aggregationTypes.sum) {
              value[series.FieldName] += Math.round(Number(itemValue) * 100) / 100;
            }

            if (aggregationType == chartUtils.aggregationTypes.count) {
              value[series.FieldName]++;
            }

            if (aggregationType == chartUtils.aggregationTypes.uniqueCount) {
              // Avoid double counting
              if (processed[item[xFieldName]].indexOf(item[series.FieldName]) > -1) continue;
              value[series.FieldName]++;

              processed[item[xFieldName]].push(item[series.FieldName]);
            }

            if (aggregationType == chartUtils.aggregationTypes.average) {
              value["total"] += itemValue == null ? 0 : Number(itemValue);

              if (item[xFieldName] == value[xFieldName] && item[series.FieldName] != null) value["counter"]++;

              if (value["counter"] > 0) value[series.FieldName] = Number(value["total"] / value["counter"]);else value[series.FieldName] = 0;
            }
          }

          baseValue[base] = value[base] + value[series.FieldName];
          totalValue["Total"] = baseValue[base];
          baseValue[series.FieldName] = value[series.FieldName];
        }

        var tempMaxValue = d3.max(tempAccumulator, function (d) {
          return Math.round((Number(d[series.FieldName]) + Number(d[base])) * 100) / 100;
        });

        maxValue = Math.max(maxValue, tempMaxValue);

        var tempMinValue = d3.min(tempAccumulator, function (d) {
          return Math.round((Number(d[base]) + Number(d[series.FieldName])) * 100) / 100;
        });

        minValue = Math.min(minValue, tempMinValue);

        seriesAccumulators[seriesName] = tempAccumulator;
      }
    }

    if (seriesConfig.length > 1) {
      var totalSeriesName = chartUtils.replaceAll(totalLabel, " ", "");
      seriesAccumulators[totalSeriesName] = totalAccumulator;
      barSeriesNames.push(totalLabel);
      seriesConfig.push(totalConfig);

      sort(baseXValues);

      for (var currentSeries = 0; currentSeries < Object.keys(seriesAccumulators).length; currentSeries++) {
        var series = Object.keys(seriesAccumulators)[currentSeries];
        chartUtils.sortByBaseSeries(baseXValues, seriesAccumulators[series], xFieldName);
      }
    }

    maxValue += maxValue / 10;
    minValue = Math.min(0, minValue);

    var maxLabelLength = 0;

    x.domain(baseXValues.map(function (d) {
      var value = d[xFieldName];
      maxLabelLength = Math.max(maxLabelLength, value.toString().length);
      return value;
    }));

    x1.domain(barSeriesNames).rangeRoundBands([0, x.rangeBand()], 0.1);

    //Compute X Axis Tick Spacing.
    xAxisTickSpacing = fontHeight / height + vPadding;
    if (Math.abs(rotationAngle) > 0) {
      xAxisTickSpacing = maxLabelLength * fontWidth * Math.sin(Math.PI * rotationAngle / 180) / height;
    }

    xAxisTickSpacing = xAxisTickSpacing > 0.25 ? 0.25 : xAxisTickSpacing;

    //Compute Y Axis Tick spacing
    var format = displayFormat == null ? ",.0f" : displayFormat;
    var value = minValue.toString().length > maxValue.toString().length ? minValue : maxValue;
    var formattedValue = chartUtils.format(value, format, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber);

    var maxValueLength = void 0;
    if (formattedValue != null) maxValueLength = formattedValue.toString().length - 1;

    yAxisTickSpacing = maxValueLength * fontWidth / width;

    var legendX = showLegend ? margin.left : 0;
    var legendY = showLegend ? margin.top : 0;
    var chartX = Number(margin.left) + Number(hPadding) + Number(yAxisTickSpacing) + Number(yAxisLabelSize);
    var chartY = !showLegend ? margin.top : margin.top + legendRectSize * legendLineCount + legendVerticalPad + legendSpacing * (legendLineCount - 1);

    chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
    var chartWidth = 1 - chartX - margin.right;
    var chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
    var xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
    var labelX = margin.left;

    if (showLegend) {
      switch (legendLocation) {
        case chartUtils.legendLocation.right:
          {
            chartWidth = 1 - chartX - margin.right - Number(legendWidth) - Number(hPadding);
            legendX = chartWidth + chartX + Number(hPadding);
            chartY = margin.top;
            chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
            chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
            xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
            break;
          }
        case chartUtils.legendLocation.left:
          {
            chartWidth = 1 - chartX - margin.right - Number(legendWidth);
            chartX += Number(legendWidth);
            labelX = Number(chartX) - Number(yAxisLabelSize) - Number(yAxisTickSpacing);
            chartY = margin.top;
            chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
            chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing)) - chartY;
            xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(vPadding);
            break;
          }
        case chartUtils.legendLocation.bottom:
          {
            chartY = margin.top;
            chartY = isNaN(fontHeight) ? chartY : chartY + fontHeight / height;
            chartHeight = 1 - (margin.bottom + Number(xAxisLabelSize) + Number(vPadding) + Number(xAxisTickSpacing) + Number(legendVerticalPad) + Number(legendRectSize)) - chartY;
            xAxisLabelY = Number(chartHeight) + Number(xAxisTickSpacing) + Number(xAxisLabelSize) / 2 + Number(vPadding);
            legendY = Number(xAxisLabelY) + Number(legendVerticalPad) + Number(xAxisLabelSize) + Number(legendRectSize) / 2;
            break;
          }
      }
    }

    legendX = chartUtils.makeRelative(legendX, width);
    legendY = chartUtils.makeRelative(legendY, height);
    legendWidth = chartUtils.makeRelative(legendWidth, width);

    chartX = Number(chartUtils.makeRelative(chartX, width));
    chartY = Number(chartUtils.makeRelative(chartY, height));
    chartWidth = chartUtils.makeRelative(chartWidth, width);
    chartHeight = chartUtils.makeRelative(chartHeight, height);
    xAxisLabelY = chartUtils.makeRelative(xAxisLabelY, height);
    labelX = chartUtils.makeRelative(labelX, width);
    textOffset = chartUtils.makeRelative(textOffset, width);

    //Define axes range and domain
    var xPadding = 0.1;
    x.rangeBands([0, chartWidth], xPadding);
    x1.rangeRoundBands([0, x.rangeBand()]);

    y.range([chartHeight, 0]).domain([minValue, maxValue]).nice(tickCount);

    var yAxis = d3.svg.axis().scale(y).orient("left").ticks(tickCount).tickFormat(function (d) {
      return chartUtils.format(d, displayFormat, currencyPrefix, maxValue, baseFormat);
    });

    var xAxis = d3.svg.axis().scale(x).orient("bottom");

    var x1Axis = d3.svg.axis().scale(x1).orient("bottom").tickFormat("").tickSize(0, 0);

    var svg = d3.select(el).append("svg").attr("width", width).attr("height", height).attr("maxValue", maxValue).attr("minValue", minValue).attr("class", "maximize-trigger").attr("viewBox", "0 0 " + width + " " + height).attr("preserveAspectRatio", "xMidYMid");

    var chartContainer = svg.append("g");

    var tempY = Number(chartY) + Number(chartHeight);

    chartContainer.append("g").attr("class", "x axis").attr("transform", "translate(" + chartX + "," + tempY + ")").style("opacity", function () {
      if (hideXAxis) return 0;
      return 1;
    }).call(xAxis);

    var xAxisLabelContainer = chartContainer.append("g").append("text").attr("class", "label x axis-label").attr("x", Number(chartWidth) / 2 + Number(chartX)).attr("y", Number(xAxisLabelY) + Number(chartY)).style("text-anchor", "middle").text(xAxisText);

    if (!hideXAxis) {
      chartContainer.selectAll(".tick").select("text").style("text-anchor", function (d) {
        if (rotationAngle > 0) return "end";
        return "middle";
      }).attr("transform", function (d) {
        return "rotate(-" + rotationAngle + ")";
      }).attr("class", function (d) {
        return "dataviz";
      }).attr("coord", function (d, i) {
        var crumb = crumbFormat;
        crumb.DefaultPerspective = defaultPerspective;
        crumb.Value = d;
        var crumbValue = chartUtils.findValue(baseXValues, crumb.FieldName, d);
        if (crumbValue != null) crumb.DisplayValue = crumbValue[crumb.DisplayFieldName];
        return JSON.stringify(crumb);
      });
    }

    chartContainer.append("g").attr("class", "y axis").attr("transform", "translate(" + chartX + "," + chartY + ")").style("opacity", function () {
      if (hideYAxis) return 0;
      return 1;
    }).call(yAxis);

    var yAxisLabelContainer = svg.append("g").append("text").attr("class", "label y axis-label").attr("transform", "rotate(-90)").attr("x", -1 * (chartHeight / 2 + chartY)).attr("y", labelX).attr("dy", "0.5em").style("text-anchor", "middle").text(yAxisText);

    var group = chartContainer.selectAll(".group").data(baseXValues).enter().append("g").attr("transform", function (d) {
      var xValue = d[xFieldName];
      return "translate(" + (x(xValue) + chartX) + "," + chartY + ")";
    }).attr("class", "group").attr("id", function (d, i) {
      return "group" + i;
    });

    var groupLengthCheck = group.length > 0 ? true : false;
    var svgInnerHeight = Number(svg.attr("innerHeight"));
    var getBaseAttribute = function getBaseAttribute(element) {
      return Number(d3.select(element).attr("base"));
    };

    if (seriesConfig != null) {
      for (var index = 0; index < seriesConfig.length; index++) {
        var series = seriesConfig[index];

        if (series.SeriesType != chartUtils.chartSeriesType.bar) continue;

        var seriesName = chartUtils.replaceAll(series.SeriesName, " ", "");

        if (seriesAccumulators[seriesName] == null) continue;

        var accumulator = seriesAccumulators[seriesName];

        if (series.ShowLabels) {
          showSeriesLabels(series.IsDebit);
        }

        group.append("rect").style("fill", function (d) {
          if (series.Color != null && series.Color.trim().length > 0) return series.Color;

          return seriesColor(seriesName);
        }).attr("x", x1(series.SeriesName)).attr("width", x1.rangeBand()).attr("label", function (d, i) {
          var value = 0;
          var displayFormat = series.ValueFormat;
          var currencyPrefix = series.CurrencySymbol;
          var baseFormat = series.BaseFormat;

          var xValue = d[xFieldName];
          var index = accumulator.map(function (e) {
            return e[xFieldName];
          }).indexOf(xValue);

          if (index < 0) return;

          if (accumulator[index] == null) return "--";

          value = Number(accumulator[index][series.FieldName]);

          if (isNaN(value)) value = 0;

          var labelPrefix = accumulator[index][tipField] == null ? accumulator[index][xFieldName] : accumulator[index][tipField];

          if (tipField == null || tipField.trim().length == 0) tipField = series.FieldName;

          var name = series.SeriesName;

          if (name.trim() == "--") name = "";

          if (series.ShowDefaultTooltip) {
            var defaultTipText = '<span class="tip-header">' + name + ':</span><span class="tip-value"> ' + chartUtils.format(value, displayFormat, currencyPrefix, maxValue, baseFormat, isDecimalPercentNumber) + "</span>";
          }

          var tooltip = series.Tooltip;

          var tipText = chartUtils.buildTooltipText(tooltip, accumulator[index], defaultTipText, series.FieldName, series.AggregationType, series.TotalRecords);

          return tipText;
        }).attr("value", function (d, i) {
          return Number(accumulator[i][series.FieldName]).toFixed(2);
        }).attr("base", function (d, i) {
          var base = Number(accumulator[i]["base"]);
          return y(base);
        }).attr("id", function (d, i) {
          return "Bar" + i;
        }).attr("coord", function (d, i) {
          crumbFormat.FieldName = series.CrumbFieldName;
          crumbFormat.Value = accumulator[i][series.CrumbFieldName];
          crumbFormat.DisplayFieldName = series.CrumbDisplayFieldName;
          crumbFormat.DisplayValue = accumulator[i][series.CrumbDisplayFieldName];
          return JSON.stringify(crumbFormat);
        }).attr("class", function (d, i) {
          var classifier = "bar dataviz editviz " + chartUtils.makeStyleName(seriesName);
          if (accumulator[i].Classifier != null) return classifier + " " + accumulator[i].Classifier;
          return classifier;
        }).attr('seriesidentifier', series.SeriesName).attr("height", 0).attr("y", function (d, i) {
          if (groupLengthCheck) {
            return getBaseAttribute(this);
          } else {
            return svgInnerHeight - 1;
          }
        }).on("click", function () {
          var selected = d3.select(this).attr("selected");

          if (selected == null) selected = "0";

          svg.selectAll("rect").attr("selected", "0").attr("stroke", "none");

          if (selected == "0") {
            d3.select(this).transition().duration(250).attr("stroke", "#ff0000").attr("selected", "1");
          } else {
            d3.select(this).transition().duration(250).attr("stroke", "none").attr("selected", "0");
          }
        }).on("touchstart", function () {
          columnTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseover", function () {
          columnTooltip.onMouseOver.call(this, parentContainerId);
        }).on("mouseout", columnTooltip.onMouseOut).on("touchmove", columnTooltip.onTouchMove).on("mousemove", function () {
          columnTooltip.onMouseMove.call(this, parentContainerId);
        }).transition().duration(500).ease(transitionEase).attr("y", function (d, i) {
          var value = Number(accumulator[i][series.FieldName]);
          var base = Number(accumulator[i]["base"]);
          if (value <= 0) return y(base);

          return y(value + base);
        }).attr("height", function (d, i) {
          var value = Number(accumulator[i][series.FieldName]);

          var base = Number(accumulator[i]["base"]);

          if (value < 0) return y(value + base) - y(base);

          return y(base) - y(value + base);
        });
      }
    }

    if (showLegend) {
      var legendItems = [];
      var legendItem = {};

      for (var i = 0; i < seriesConfig.length; i++) {
        var series = seriesConfig[i];

        var seriesName = chartUtils.replaceAll(series.SeriesName, " ", "");

        legendItem = chartUtils.findValue(legendItems, "SeriesName", seriesName);
        if (legendItem != null) continue;

        legendItem = {};
        legendItem["SeriesCode"] = seriesName;
        seriesName = "SeriesName";

        if (series.StackOnField != null) seriesName = series.StackOnField;
        if (series.GroupOnField != null) seriesName = series.GroupOnField;

        legendItem[seriesName] = series.SeriesName;
        legendItem["ClassName"] = series.ClassName;
        legendItem["SeriesNameValue"] = series.SeriesName;
        legendItem["Color"] = series.Color;
        legendItems.push(legendItem);

        if (series.SubSeries != null) {
          for (var index = 0; index < series.SubSeries.length; index++) {
            legendItem = {};
            seriesName = chartUtils.replaceAll(series.SubSeries[index].SeriesName, " ", "");
            legendItem["SeriesCode"] = seriesName;
            seriesName = "SeriesName";

            if (series.StackOnField != null) seriesName = series.StackOnField;
            if (series.GroupOnField != null) seriesName = series.GroupOnField;

            legendItem[seriesName] = series.SubSeries[index].SeriesName;
            legendItem["ClassName"] = series.SubSeries[index].ClassName;
            legendItem["SeriesNameValue"] = series.SubSeries[index].SeriesName;
            legendItem["Color"] = series.SubSeries[index].Color;
            legendItems.push(legendItem);
          }
        }
      }

      if (series.StackOnField != null || series.GroupOnField != null) {
        if (seriesName.toLocaleLowerCase().indexOf("month") >= 0) {
          chartUtils.sort(legendItems, seriesName);
        } else if (seriesName.toLocaleLowerCase().indexOf("day") >= 0) {
          chartUtils.sort(legendItems, seriesName);
        } else {
          legendItems.sort(function (a, b) {
            return a.SeriesNameValue > b.SeriesNameValue ? 1 : b.SeriesNameValue > a.SeriesNameValue ? -1 : 0;
          });
        }
      }

      var legendHeight = Number(legendItems.length) * Number(legendRectSize) + Number(legendSpacing) + Number(offset);

      legendHeight = chartUtils.makeRelative(legendHeight, height);
      legendRectSize = chartUtils.makeRelative(legendRectSize, Math.min(width, height));
      legendSpacing = chartUtils.makeRelative(legendSpacing, height);
      offset = chartUtils.makeRelative(offset, height);

      if (legendLocation == chartUtils.legendLocation.left || legendLocation == chartUtils.legendLocation.right) legendY = chartHeight / 2 - legendHeight / 2 + chartY;

      var legendCount = legendItems.length;
      var legendCountInOneLine = Math.ceil(legendCount / legendLineCount);
      var legendSectionWidth = (width - Number(chartX) - margin.right * width) / legendCountInOneLine;
      var currentLegendLine = 0;

      var legendContainer = svg.append("g");
      legendContainer.attr("transform", "translate(" + legendX + "," + legendY + ")");

      var legend = legendContainer.selectAll(".legend").data(legendItems).enter().append("g").attr("class", function (d) {
        return "legend " + d["SeriesCode"];
      }).attr("transform", function (d, i) {
        var itemHeight = Number(legendRectSize) + Number(legendSpacing);
        var horz = 0;
        var vert = i * (Number(itemHeight) + Number(offset));

        if (legendLocation == chartUtils.legendLocation.top || legendLocation == chartUtils.legendLocation.bottom) {
          horz = i % legendCountInOneLine * Number(legendSectionWidth) + Number(legendSpacing) + Number(chartX);
          vert = Math.floor(i / legendCountInOneLine) * (Number(legendRectSize) + Number(legendSpacing) + Number(offset));
        }

        return "translate(" + horz + "," + vert + ")";
      });

      legend.append("rect").attr("width", legendRectSize).attr("height", legendRectSize).attr("class", function (d) {
        return "legend " + d["ClassName"];
      }).attr("label", function (d) {
        return d[seriesName];
      }).style("fill", function (d) {
        if (d.Color != null && d.Color.trim().length > 0) return d.Color;

        return seriesColor(d["SeriesCode"]);
      });

      legend.append("text").attr("x", Number(legendRectSize) + Number(legendSpacing)).attr("y", legendRectSize / 2).style("text-anchor", "start").style("dominant-baseline", "central").text(function (d) {
        return d[seriesName];
      });
    }

    function sort(accumulator) {
      accumulator.sort(function (d1, d2) {
        if (sortByDate) {
          var date1 = d1[xFieldName].split("-");

          if (date1 != null && date1.length >= 2) {
            var len = date1.length;
            var date2 = d2[xFieldName].split("-");
            var y1 = Number(date1[len - 1]);
            var y2 = Number(date2[len - 1]);
            var m1 = chartUtils.toMonthNumber(date1[len - 2]);
            var m2 = chartUtils.toMonthNumber(date2[len - 2]);
            if (y1 == y2) return m1 - m2;

            return y1 - y2;
          }
        }
        if (xFieldName.toLocaleLowerCase().indexOf("quarter") >= 0) {
          var q1 = chartUtils.toQuarterNumber(d1[xFieldName]);
          var q2 = chartUtils.toQuarterNumber(d2[xFieldName]);
          return q1 - q2;
        }

        if (xFieldName.toLocaleLowerCase().indexOf("year") >= 0) return d1[xFieldName] - d2[xFieldName];

        if (xFieldName.toLocaleLowerCase().indexOf("month") >= 0) {
          var m1 = chartUtils.toMonthNumber(d1[xFieldName]);
          var m2 = chartUtils.toMonthNumber(d2[xFieldName]);
          return m1 - m2;
        }
        return d2[series.FieldName] + d2[base] - (d1[series.FieldName] + d1[base]);
      });
    }

    function showSeriesLabels(isDebit) {
      chartContainer.selectAll(".text").data(accumulator).enter().append("text").attr("transform", function (d, i) {
        var xPos = x(d[xFieldName]) + x1(d["series"]) + x1.rangeBand() / 2 + chartX;
        var ypos = void 0;
        if (isDebit || d[series.FieldName] < 0) ypos = y(d[series.FieldName] + d["base"]) + 2;else ypos = y(d[series.FieldName] + d["base"]) - 2;
        return "translate(" + xPos + "," + (ypos + chartY) + ")";
      }).text(function (d) {
        return chartUtils.format(Number(d[series.FieldName]), series.ValueFormat, series.CurrencySymbol, maxValue, series.BaseFormat);
      }).style("text-anchor", function (d) {
        return "middle";
      }).style("dominant-baseline", function (d) {
        if (isDebit || d[series.FieldName] < 0) return "text-before-edge";else return "text-after-edge";
      }).attr("class", function (d) {
        return "column-label";
      }).attr("opacity", 0).transition().delay(500).duration(200).attr("opacity", 1);
    }
  };
  // Initiate rendering for a widget
  var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
    // Get widget specific widgetConfig
    var widgetConfig = waterfallChartConfigBuilder.configBuilder(cloneDeep(configObj));
    renderWidget(widgetConfig);
  };
  return {
    renderWidget: renderWidget,
    initiateWidgetRendering: initiateWidgetRendering
  };
};
export default waterfallChart();